import { LOGO_URL, NAV_LINKS } from "@/lib/site";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (!el) { window.location.href = `/#${id}`; return; }
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80, duration: 1.2 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] text-[#FAFAF7] border-t border-white/10">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10 py-14 md:py-16 grid grid-cols-12 gap-8">
        <div className="col-span-12 md:col-span-5">
          <img src={LOGO_URL} alt="Hudak Enterprises" className="h-11 w-auto invert" />
          <p className="mt-5 text-[#FAFAF7]/60 text-sm max-w-sm leading-relaxed">
            Digitalagentur aus Bern. Webseiten, Content und Performance Marketing — als ein System, das Anfragen liefert.
          </p>
        </div>

        <div className="col-span-6 md:col-span-3">
          <div className="font-mono-eyebrow text-[#C9A961] mb-4">Navigation</div>
          <ul className="space-y-2">
            {NAV_LINKS.map((l) => (
              <li key={l.id}>
                <Link to={`/#${l.id}`} className="text-sm text-[#FAFAF7]/80 hover:text-[#C9A961] transition-colors duration-300" data-testid={`footer-link-${l.id}`}>
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="col-span-6 md:col-span-4">
          <div className="font-mono-eyebrow text-[#C9A961] mb-4">Kontakt</div>
          <ul className="space-y-2 text-sm text-[#FAFAF7]/80">
            <li>Sonnrainstrasse 13</li>
            <li>3510 Konolfingen · Schweiz</li>
            <li>mhudak@hudakenterprises.ch</li>
            <li>+41 77 435 15 61</li>
          </ul>
          <div className="mt-6 flex gap-2">
            {["LinkedIn", "Instagram"].map((s) => (
              <a key={s} href="#" className="px-3 py-1.5 rounded-full border border-white/10 text-xs uppercase tracking-[0.18em] hover:border-[#C9A961] hover:text-[#C9A961] transition-colors">
                {s}
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto max-w-[1440px] px-5 md:px-10 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-[#FAFAF7]/50">
          <div>© {new Date().getFullYear()} Hudak Enterprises · Bern, Schweiz</div>
          <div className="flex gap-6">
            <Link to="/impressum" data-testid="footer-impressum" className="hover:text-[#C9A961] transition-colors">Impressum</Link>
            <Link to="/datenschutz" data-testid="footer-datenschutz" className="hover:text-[#C9A961] transition-colors">Datenschutz</Link>
            <button
              type="button"
              onClick={() => {
                try { localStorage.removeItem("he_consent_v1"); } catch {}
                window.location.reload();
              }}
              data-testid="footer-cookie-settings"
              className="hover:text-[#C9A961] transition-colors"
            >
              Cookie-Einstellungen
            </button>
          </div>
          <a href="#start" className="inline-flex items-center gap-2 hover:text-[#C9A961] transition-colors">
            Nach oben <ArrowUpRight size={13} />
          </a>
        </div>
      </div>
    </footer>
  );
}
